import { render } from "./UserProfile.vue?vue&type=template&id=c579b492&scoped=true&ts=true"
import script from "./UserProfile.vue?vue&type=script&lang=ts"
export * from "./UserProfile.vue?vue&type=script&lang=ts"

import "./UserProfile.vue?vue&type=style&index=0&id=c579b492&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c579b492"]])

export default __exports__